import React from 'react';

const Image = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path d="M 31.36,4.48 L 31.36,27.52 L 0.64,27.52 L 0.64,4.48 Z M 1.92,26.24 L 30.080,26.24 L 30.080,5.76 L 1.92,5.76 Z M 1.92,26.24M 18.665,14.884 L 28.874,24.986 L 3.264,24.986 L 3.298,14.253 L 7.059,11.008 L 14.766,18.626 Z M 4.548,23.706 L 25.761,23.706 L 18.651,16.671 L 15.653,19.55 L 14.753,20.413 L 13.866,19.537 L 7,12.75 L 4.577,14.841 Z M 4.548,23.706M 21.12,11.584 C 21.12,9.817 22.553,8.384 24.32,8.384 C 26.087,8.384 27.52,9.817 27.52,11.584 C 27.52,13.351 26.087,14.784 24.32,14.784 C 22.553,14.784 21.12,13.351 21.12,11.584 Z M 26.24,11.584 C 26.24,10.524 25.38,9.664 24.32,9.664 C 23.26,9.664 22.4,10.524 22.4,11.584 C 22.4,12.644 23.26,13.504 24.32,13.504 C 25.38,13.504 26.24,12.644 26.24,11.584 Z M 26.24,11.584" />
  </svg>
);

export default Image;
